export const CLINIC_SERVICE_ORDER = [
  "nieng-rang",
  "trong-rang-implant",
  "boc-rang-su",
  "nho-rang-khon",
  "dieu-tri-tuy",
  "rang-gia-thao-lap",
  "tay-trang-rang",
  "chup-x-quang-rang",
  "nho-rang",
  "tram-rang",
  "lay-cao-rang",
  "kham-rang-mieng",
  "dan-rang-su",
  "dieu-tri-cuoi-ho-loi",
  "dieu-tri-viem-nuou",
  "dieu-tri-roi-loai-khop-thai-duong-ham",
  "phau-thuat-ham-mat",
  "dinh-da",
  "dieu-tri-nha-chu",
  "phuc-hinh-rang-co-dinh",
  "danh-bong-rang",
  "dieu-tri-viem-nuou",
];
